"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearStatus = exports.clear = exports.toggleModal = exports.fetchReliablePartnerReportFailure = exports.updateReliablePartnerPdfStatusFailure = exports.updateReliablePartnerPdfStatusSuccess = exports.updateReliablePartnerStatusFailure = exports.updateReliablePartnerStatusSuccess = exports.fetchReliablePartnerReportSuccess = exports.fetchReliablePartnerReportRequest = exports.toggleCompanyInfoApprove = exports.setOfferCompanyInfo = exports.removeFile = exports.fetchPendingFilesFailed = exports.fetchPendingFilesSuccess = exports.fetchPendingFilesRequest = exports.declineSectionFailed = exports.declineSectionSuccess = exports.declineSectionRequest = exports.approveSectionFailed = exports.approveSectionSuccess = exports.approveSectionRequest = exports.toggleDocuments = exports.editNoteFailed = exports.editNoteSuccess = exports.editNoteRequest = exports.addNoteFailed = exports.addNoteSuccess = exports.addNoteRequest = exports.fetchNotesFailed = exports.fetchNotesSuccess = exports.fetchNotesRequest = exports.submitFailed = exports.submitSuccess = exports.submitRequest = exports.fetchSchemaFailure = exports.fetchSchemaSuccess = exports.fetchSchema = exports.fetchFilesFailed = exports.fetchFilesSuccess = exports.fetchFilesRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = exports.searchOptions = exports.sortByOptions = exports.RevisionActions = exports.PreviewActions = exports.ListActions = exports.MetaschemaActions = void 0;
const fp = require("fp-ts");
const ActionTypes = require("../../actionTypes/bid/tender");
const _ListActions = require("../../modules/files/list/actions");
const _MetaschemaActions = require("../../modules/metaschema/actions");
const _PreviewActions = require("../../modules/files/preview/actions");
const _RevisionsActions = require("../../modules/revisions/actions");
exports.MetaschemaActions = _MetaschemaActions.default('tender-documents');
exports.ListActions = _ListActions.default('tender-documents');
exports.PreviewActions = _PreviewActions.default('tender-documents');
exports.RevisionActions = _RevisionsActions.default('tender-documents');
exports.sortByOptions = {
    sortBy: '',
    order: 'asc',
    limit: 0,
    offset: 0
};
exports.searchOptions = {
    filtering: 'NONE',
    from: null,
    to: null,
    meta: null,
    metaValue: null,
    moreSearch: false,
    toggleRecents: false,
    toggleShowBookmarks: false,
    toggleHideEmptyFolders: false,
    limitSearchToMetadata: false,
    searchString: '',
    searchFileType: fp.option.none,
    limitSearchToFolder: fp.option.none
};
function fetchRequest(bid, participantId) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        payload: {
            bid,
            participantId
        }
    };
}
exports.fetchRequest = fetchRequest;
function fetchSuccess(participant, tender, suitability, requestToParticipant, reliablePartner, submitted, company = null, businessId = null, reliablePartnerStatus = null) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload: {
            participant,
            tender,
            suitability,
            requestToParticipant,
            reliablePartner,
            submitted,
            company,
            businessId,
            reliablePartnerStatus
        }
    };
}
exports.fetchSuccess = fetchSuccess;
function fetchFailed(payload) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload
    };
}
exports.fetchFailed = fetchFailed;
exports.fetchFilesRequest = exports.ListActions.fetchRequest;
exports.fetchFilesSuccess = exports.ListActions.fetchSuccess;
exports.fetchFilesFailed = exports.ListActions.fetchFailure;
exports.fetchSchema = exports.MetaschemaActions.fetchSchema;
exports.fetchSchemaSuccess = exports.MetaschemaActions.fetchSchemaSuccess;
exports.fetchSchemaFailure = exports.MetaschemaActions.fetchSchemaFailure;
function submitRequest(bid, participant, uploadSessions, removedFiles, companyName, businessId) {
    return {
        type: ActionTypes.SUBMIT_REQUEST,
        payload: {
            bid,
            participant,
            uploadSessions,
            removedFiles,
            companyName: companyName || undefined,
            businessId: businessId || undefined
        }
    };
}
exports.submitRequest = submitRequest;
function submitSuccess() {
    return {
        type: ActionTypes.SUBMIT_SUCCESS
    };
}
exports.submitSuccess = submitSuccess;
function submitFailed(payload) {
    return {
        type: ActionTypes.SUBMIT_FAILED,
        payload
    };
}
exports.submitFailed = submitFailed;
function fetchNotesRequest(bid, participantId) {
    return {
        type: ActionTypes.FETCH_NOTES_REQUEST,
        payload: {
            bid,
            participantId
        }
    };
}
exports.fetchNotesRequest = fetchNotesRequest;
function fetchNotesSuccess(notes) {
    return {
        type: ActionTypes.FETCH_NOTES_SUCCESS,
        payload: notes
    };
}
exports.fetchNotesSuccess = fetchNotesSuccess;
function fetchNotesFailed(payload) {
    return {
        type: ActionTypes.FETCH_NOTES_FAILED,
        payload
    };
}
exports.fetchNotesFailed = fetchNotesFailed;
function addNoteRequest(bid, participantId, note) {
    return {
        type: ActionTypes.ADD_NOTE_REQUEST,
        payload: {
            bid,
            participantId,
            note
        }
    };
}
exports.addNoteRequest = addNoteRequest;
function addNoteSuccess() {
    return {
        type: ActionTypes.ADD_NOTE_SUCCESS
    };
}
exports.addNoteSuccess = addNoteSuccess;
function addNoteFailed(payload) {
    return {
        type: ActionTypes.ADD_NOTE_FAILED,
        payload
    };
}
exports.addNoteFailed = addNoteFailed;
function editNoteRequest(bid, participantId, note) {
    return {
        type: ActionTypes.EDIT_NOTE_REQUEST,
        payload: {
            bid,
            participantId,
            note
        }
    };
}
exports.editNoteRequest = editNoteRequest;
function editNoteSuccess() {
    return {
        type: ActionTypes.EDIT_NOTE_SUCCESS
    };
}
exports.editNoteSuccess = editNoteSuccess;
function editNoteFailed(payload) {
    return {
        type: ActionTypes.EDIT_NOTE_FAILED,
        payload
    };
}
exports.editNoteFailed = editNoteFailed;
function toggleDocuments(items, status) {
    return {
        type: ActionTypes.TOGGLE_DOCUMENTS,
        payload: {
            items,
            status
        }
    };
}
exports.toggleDocuments = toggleDocuments;
function approveSectionRequest(bid, participant, section) {
    return {
        type: ActionTypes.APPROVE_SECTION_REQUEST,
        payload: {
            bid,
            participant
        },
        section
    };
}
exports.approveSectionRequest = approveSectionRequest;
function approveSectionSuccess(section) {
    return {
        type: ActionTypes.APPROVE_SECTION_SUCCESS,
        section
    };
}
exports.approveSectionSuccess = approveSectionSuccess;
function approveSectionFailed(payload, section) {
    return {
        type: ActionTypes.APPROVE_SECTION_FAILED,
        payload,
        section
    };
}
exports.approveSectionFailed = approveSectionFailed;
function declineSectionRequest(bid, participant, section) {
    return {
        type: ActionTypes.DECLINE_SECTION_REQUEST,
        payload: {
            bid,
            participant
        },
        section
    };
}
exports.declineSectionRequest = declineSectionRequest;
function declineSectionSuccess(section) {
    return {
        type: ActionTypes.DECLINE_SECTION_SUCCESS,
        section
    };
}
exports.declineSectionSuccess = declineSectionSuccess;
function declineSectionFailed(payload, section) {
    return {
        type: ActionTypes.DECLINE_SECTION_FAILED,
        payload,
        section
    };
}
exports.declineSectionFailed = declineSectionFailed;
function fetchPendingFilesRequest(session, section) {
    return {
        type: ActionTypes.FETCH_PENDING_FILES_REQUEST,
        payload: session,
        section
    };
}
exports.fetchPendingFilesRequest = fetchPendingFilesRequest;
function fetchPendingFilesSuccess(files, section) {
    return {
        type: ActionTypes.FETCH_PENDING_FILES_SUCCESS,
        payload: files,
        section
    };
}
exports.fetchPendingFilesSuccess = fetchPendingFilesSuccess;
function fetchPendingFilesFailed(payload, section) {
    return {
        type: ActionTypes.FETCH_PENDING_FILES_FAILED,
        payload,
        section
    };
}
exports.fetchPendingFilesFailed = fetchPendingFilesFailed;
function removeFile(payload, section) {
    return {
        type: ActionTypes.REMOVE_FILE,
        payload,
        section
    };
}
exports.removeFile = removeFile;
function setOfferCompanyInfo(company, businessId) {
    return {
        type: ActionTypes.SET_OFFER_COMPANY_INFO,
        payload: {
            company,
            businessId
        }
    };
}
exports.setOfferCompanyInfo = setOfferCompanyInfo;
function toggleCompanyInfoApprove() {
    return {
        type: ActionTypes.TOGGLE_COMPANY_INFO_APPROVE
    };
}
exports.toggleCompanyInfoApprove = toggleCompanyInfoApprove;
function fetchReliablePartnerReportRequest(bid, participant) {
    return {
        type: ActionTypes.FETCH_RELIABLE_PARTNER_REPORT_REQUEST,
        payload: { bid, participant }
    };
}
exports.fetchReliablePartnerReportRequest = fetchReliablePartnerReportRequest;
function fetchReliablePartnerReportSuccess() {
    return {
        type: ActionTypes.FETCH_RELIABLE_PARTNER_REPORT_SUCCESS
    };
}
exports.fetchReliablePartnerReportSuccess = fetchReliablePartnerReportSuccess;
const updateReliablePartnerStatusSuccess = (payload) => ({
    type: ActionTypes.UPDATE_RELIABLE_PARTNER_STATUS_SUCCESS,
    payload
});
exports.updateReliablePartnerStatusSuccess = updateReliablePartnerStatusSuccess;
const updateReliablePartnerStatusFailure = (payload) => ({
    type: ActionTypes.UPDATE_RELIABLE_PARTNER_STATUS_FAILURE,
    payload
});
exports.updateReliablePartnerStatusFailure = updateReliablePartnerStatusFailure;
const updateReliablePartnerPdfStatusSuccess = (payload) => ({
    type: ActionTypes.GENERATE_REPORT_STATUS_SUCCESS,
    payload
});
exports.updateReliablePartnerPdfStatusSuccess = updateReliablePartnerPdfStatusSuccess;
const updateReliablePartnerPdfStatusFailure = (payload) => ({
    type: ActionTypes.GENERATE_REPORT_STATUS_FAILED,
    payload
});
exports.updateReliablePartnerPdfStatusFailure = updateReliablePartnerPdfStatusFailure;
function fetchReliablePartnerReportFailure(payload) {
    return {
        type: ActionTypes.FETCH_RELIABLE_PARTNER_REPORT_FAILURE,
        payload
    };
}
exports.fetchReliablePartnerReportFailure = fetchReliablePartnerReportFailure;
const toggleModal = () => ({
    type: ActionTypes.TOGGLE_MODAL
});
exports.toggleModal = toggleModal;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
const clearStatus = () => ({
    type: ActionTypes.CLEAR_STATUS
});
exports.clearStatus = clearStatus;
//# sourceMappingURL=tender.js.map